var _mask, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_162_5862",
    maskUnits: "userSpaceOnUse",
    x: 0.632324,
    y: 0,
    width: 26,
    height: 26,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 0.632324,
    width: 26,
    height: 26
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 4C17 2.34315 15.6569 1 14 1C12.3431 1 11 2.34315 11 4V10H4.63232C2.97547 10 1.63232 11.3431 1.63232 13C1.63232 14.6569 2.97547 16 4.63232 16H11V22C11 23.6569 12.3431 25 14 25C15.6569 25 17 23.6569 17 22V16H22.6323C24.2892 16 25.6323 14.6569 25.6323 13C25.6323 11.3431 24.2892 10 22.6323 10H17V4Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 4C17 2.34315 15.6569 1 14 1C12.3431 1 11 2.34315 11 4V10H4.63232C2.97547 10 1.63232 11.3431 1.63232 13C1.63232 14.6569 2.97547 16 4.63232 16H11V22C11 23.6569 12.3431 25 14 25C15.6569 25 17 23.6569 17 22V16H22.6323C24.2892 16 25.6323 14.6569 25.6323 13C25.6323 11.3431 24.2892 10 22.6323 10H17V4Z",
    fill: "#2FC986"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 10V11H12V10H11ZM11 16H12V15H11V16ZM17 16V15H16V16H17ZM17 10H16V11H17V10ZM14 2C15.1046 2 16 2.89543 16 4H18C18 1.79086 16.2091 0 14 0V2ZM12 4C12 2.89543 12.8954 2 14 2V0C11.7909 0 10 1.79086 10 4H12ZM12 10V4H10V10H12ZM4.63232 11H11V9H4.63232V11ZM2.63232 13C2.63232 11.8954 3.52775 11 4.63232 11V9C2.42319 9 0.632324 10.7909 0.632324 13H2.63232ZM4.63232 15C3.52775 15 2.63232 14.1046 2.63232 13H0.632324C0.632324 15.2091 2.42319 17 4.63232 17V15ZM11 15H4.63232V17H11V15ZM12 22V16H10V22H12ZM14 24C12.8954 24 12 23.1046 12 22H10C10 24.2091 11.7909 26 14 26V24ZM16 22C16 23.1046 15.1046 24 14 24V26C16.2091 26 18 24.2091 18 22H16ZM16 16V22H18V16H16ZM22.6323 15H17V17H22.6323V15ZM24.6323 13C24.6323 14.1046 23.7369 15 22.6323 15V17C24.8415 17 26.6323 15.2091 26.6323 13H24.6323ZM22.6323 11C23.7369 11 24.6323 11.8954 24.6323 13H26.6323C26.6323 10.7909 24.8415 9 22.6323 9V11ZM17 11H22.6323V9H17V11ZM16 4V10H18V4H16Z",
    fill: "#333333",
    mask: "url(#path-1-outside-1_162_5862)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.ec1f597d8a6f0231a6ed16bd593513d4.svg";
export { ForwardRef as ReactComponent };